<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :value="value"
    @input="(method) => $emit('input', method)"
    :reduce="(method) => method.value"
  />
</template>
<script>
export default {
  name: 'InvoiceDeliveryMethodSelect',
  props: {
    value: String,
    id: {
      type: String,
      default: 'invoice-delivery-method-select',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: {
      type: String,
      default: 'Select a Delivery Method',
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getInvoiceDeliveryMethodOptions();
  },
  methods: {
    deliveryMethodLabel(value) {
      return this.$options.filters.capitalizeFormat(this.$options.filters.humanizedFormat(value));
    },
    getInvoiceDeliveryMethodOptions() {
      this.$clientsAPI.getInvoiceDeliveryMethodOptions().then((response) => {
        this.options = response.data.invoice_delivery_method_options.map((option) => {
          const value = option[1];
          return { label: this.deliveryMethodLabel(value), value };
        });
      });
    },
  },
};
</script>
